<template>
    <div class="evaluate fr">
        <div>
            <img src="/static/imgs/home/avatar.png" alt class="avatar" />
        </div>
        <div class="eval_right">
            <div class="fr ac jsb mb10">
                <p class="fz14 black">{{info.member_nick_name}}</p>
                <p class="fz14 black">{{info.create_time}}</p>
            </div>
            <el-rate
                :value="info.assessment_star1"
                disabled
                :colors="['#458EF6','#458EF6','#458EF6']"
            ></el-rate>
            <p
                class="fz14 black mt10 mb10"
            >{{info.assessment_desc?info.assessment_desc:"此用户未填写评价!"}}</p>
            <div v-if="info.assessment_imgs.length" class="fr fw">
                <el-image
                    :src="i"
                    v-for="(i,k) in info.assessment_imgs.split(',')"
                    :key="k"
                    class="mr10"
                    :preview-src-list="info.assessment_imgs.split(',')"
                />
                <!-- preview="1" -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        info: Object
    },
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {},
    methods: {},
    components: {}
};
</script>

<style scoped lang="scss">
.evaluate {
    padding: 20px 0;
    border-bottom: 1px solid #dcdcdc;
    .avatar {
        width: 60px;
        height: 60px;
    }
    .eval_right {
        margin-left: 20px;
        width: calc(100% - 80px);
        .el-image {
            width: 100px;
            height: 100px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluateCell.vue